//angular imports
import { ChangeDetectionStrategy, Component, input } from "@angular/core";

//local imports
import {
  CloseDialogMessage,
  CommandModel,
  Messenger,
} from "@app/shared";
import {
  CreateProgramRequest,
  ProgramDetails,
  ProgramHttpService,
} from "@app/catalog";
import { ToastLevel, ToastMessage } from "@app/components";
import { ProgramAlreadyExistsFault, ProgramAlreadyExistsMessage } from "@app/catalog-common";

@Component({
  selector: "add-program-form",
  templateUrl: "./add-program-form.component.html",
  styleUrl: "./add-program-form.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AddProgramFormComponent {
  public details = ProgramDetails.empty();

  public companyId = input.required<string>();
  
  public cancelCommand = new CommandModel({
    executeAction: () => {
      this.messenger.send(new CloseDialogMessage());
      return Promise.resolve();
    },
  });

  public submitCommand = new CommandModel({
    executeAction: () => this.save(),
    isValid: this.details.isValid,
  });

  constructor(
    private messenger: Messenger,
    private programHttpService: ProgramHttpService
  ) {}

  private save = async () => {
    let request = new CreateProgramRequest();
    request.name = this.details.name.value();
    request.description = this.details.description.value();
    request.companyId = this.companyId();

    let createResult = this.programHttpService.create(request);

    try {
      await createResult.response;
      this.cancelCommand.execute();
    } catch (error) {
      if(error instanceof ProgramAlreadyExistsFault) {
        this.messenger.send(ToastMessage.create(new ProgramAlreadyExistsMessage(error.name), ToastLevel.Warning));
      }
    }

  };
}
